
import * as types from '../mutation-types'
import partnerResources from '@/api/partnerResources'

const state = {
  resource: [],
  eventResourcesList: [],
  resourceSectionList: []
}

const getters = {
  resource: (state) => {
    return state.resource
  },
  eventResourcesList: (state) => {
    return state.eventResourcesList
  },
  resourceSectionList: (state) => {
    return state.resourceSectionList
  }
}

const actions = {
  addResourcesByPartnerSection ({ commit }, data) {
    return new Promise((resolve, reject) => {
      partnerResources.addResource(data).then((response) => {
        const resource = response.data.result.partnerResource
        commit(types.PARTNER_RESOURCES, resource)
        resolve(resource)
      }, (error) => {
        reject(error)
      })
    })
  },
  getResourcesByEvent ({ commit }) {
    return new Promise((resolve, reject) => {
      partnerResources.getResourcesByEvent().then((response) => {
        const resources = response.data.result.resourcesWithSections
        resolve(resources)
      }, (error) => {
        reject(error)
      })
    })
  },
  createResourceSection ({ commit }, data) {
    return new Promise((resolve, reject) => {
      partnerResources.createResourceSection(data).then((response) => {
        const section = response.data.result.resourceSection
        commit(types.ADD_SECTION, section)
        resolve(section)
      }, (error) => {
        reject(error)
      })
    })
  },
  getSectionsByPartner ({ commit, state }, eventID) {
    commit(types.CLEAR_SECTIONLIST)
    return new Promise((resolve, reject) => {
      partnerResources.getSectionsByPartner(eventID).then((response) => {
        const sectionList = response.data.result.resourceSections
        sectionList.forEach((section) => {
          commit(types.ADD_SECTION, section)
        })
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  getResourcesBySection ({ commit, state }, { eventID, sectionID }) {
    commit(types.CLEAR_RESOURCESLIST)
    return new Promise((resolve, reject) => {
      partnerResources.getResourcesBySection(eventID, sectionID).then((response) => {
        const resourceList = response.data.result.resourcesWithSection
        resourceList.forEach((resource) => {
          commit(types.PARTNER_RESOURCES, resource)
        })
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteResource ({ commit, state }, resourceID) {
    return new Promise((resolve, reject) => {
      partnerResources.deleteResourceById(resourceID).then((response) => {
        const success = response.data.result.success
        commit(types.DELETE_RESOURCE, resourceID)
        resolve(success)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteSectionById ({ commit, state }, sectionID) {
    return new Promise((resolve, reject) => {
      partnerResources.deleteSectionById(sectionID).then((response) => {
        const success = response.data.result.success
        commit(types.DELETE_SECTION, sectionID)
        resolve(success)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateResource ({ commit }, { resourceID, data }) {
    return new Promise((resolve, reject) => {
      partnerResources.updateResource(resourceID, data).then((response) => {
        const updatedResource = response.data.result.updatedResource
        commit(types.UPDATE_RESOURCE, updatedResource)
        resolve(updatedResource)
      }, (error) => {
        reject(error)
      })
    })
  },
  clearResources ({ commit }) {
    return new Promise(() => {
      commit(types.CLEAR_RESOURCESLIST)
    })
  }
}

const mutations = {
  [types.CLEAR_RESOURCESLIST] (state) {
    state.eventResourcesList = []
  },
  [types.CLEAR_SECTIONLIST] (state) {
    state.resourceSectionList = []
  },
  [types.PARTNER_RESOURCES] (state, resources) {
    state.eventResourcesList.push(resources)
  },
  [types.ADD_SECTION] (state, section) {
    state.resourceSectionList.push(section)
  },
  [types.DELETE_RESOURCE] (state, resourceID) {
    state.eventResourcesList[resourceID] = null
  },
  [types.DELETE_SECTION] (state, sectionID) {
    state.resourceSectionList[sectionID] = null
  },
  [types.UPDATE_RESOURCE] (state, updatedResource) {
    state.eventResourcesList.forEach((resource, index) => {
      if (updatedResource.id === resource.id) {
        state.eventResourcesList[index].title = updatedResource.title
        state.eventResourcesList[index].description = updatedResource.description
        state.eventResourcesList[index].image = updatedResource.image
        state.eventResourcesList[index].url = updatedResource.url
        state.eventResourcesList[index].isVideo = updatedResource.isVideo
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
